import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-global-navigation.css';

var getClassNameList = classNames.bind(styles);
var GlobalNavigationSiteFooter = function (props) {
    var className = props.className, children = props.children;
    var baseCssClass = 'global-navigation-footer';
    var wrapperClassNames = getClassNameList(baseCssClass, className);
    var containerClassNames = getClassNameList("".concat(baseCssClass, "-container"));
    return (React.createElement("footer", { className: wrapperClassNames },
        React.createElement("div", { className: containerClassNames }, children)));
};
GlobalNavigationSiteFooter.displayName = 'GlobalNavigationSiteFooter';

export { GlobalNavigationSiteFooter };
